import React from "react";
import UserLayout from "../../components/user-layout/UserLayout";
import backgroundImg from "../../assets/images/not-found.jpg";
import styles from "./notFound.module.scss";
import { NavLink } from "react-router-dom";
const NotFound = () => {
  return (
    <UserLayout>
      <section className={styles.notFoundWrapper}>
        <div>
          <h1 className={styles.notFoundWrapper_heading}>Oops...</h1>
          <p className={styles.notFoundWrapper_body}>
            Could not find the page you're looking for
          </p>
          <img
            className={styles.img}
            src={require("../../assets/images/not-found.jpg")}
            alt=""
          />
        </div>
        <NavLink className={styles.link} to="/">
          Back to home
        </NavLink>
      </section>
    </UserLayout>
  );
};

export default NotFound;
